export default __webpack_public_path__ + "static/media/photo--lg--119.a33f4b17.jpg";